import React from "react";

interface Props {
  onBack: () => void;
}

interface Binding {
  readonly keys: readonly string[];
  readonly action: string;
}

const BINDINGS: readonly Binding[] = [
  { keys: ["W", "A", "S", "D"], action: "Move forward / strafe / back" },
  { keys: ["↑", "↓", "←", "→"], action: "Move and turn (arrow keys)" },
  { keys: ["Q", "E"], action: "Turn left / right" },
  { keys: ["Shift"], action: "Hold to sneak (halves movement + noise)" },
  { keys: ["Esc"], action: "Open the menu (or close any open overlay)" },
  { keys: ["Click"], action: "Attack an enemy, talk to an NPC, toggle a door" },
];

/**
 * U02 — keybinding + how-to-play overlay.
 *
 * Reached from `MainMenu` → "Help". One screen; no tabs. Copy is
 * deliberately short — a new playtester should be able to skim it in
 * under thirty seconds and close the menu.
 */
export function HelpScreen({ onBack }: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        color: "white",
        fontFamily: "monospace",
        fontSize: 13,
        maxWidth: 480,
        width: "100%",
      }}
    >
      <h2 style={{ margin: 0, fontSize: 18, letterSpacing: 2 }}>HELP</h2>

      <p style={{ margin: 0, lineHeight: 1.5, color: "#ccc" }}>
        bkcrawl is a turn-based grid dungeon crawler. Your party moves one
        cell at a time. Click enemies to attack, NPCs to talk, and doors
        to open them. Explore carefully — traps and hostile creatures
        don&apos;t telegraph themselves.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          gap: "6px 16px",
          alignItems: "center",
        }}
      >
        {BINDINGS.map((b) => (
          <React.Fragment key={b.action}>
            <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
              {b.keys.map((k) => (
                <Key key={k} label={k} />
              ))}
            </div>
            <div style={{ color: "#ddd" }}>{b.action}</div>
          </React.Fragment>
        ))}
      </div>

      <button
        onClick={onBack}
        style={{
          background: "#333",
          color: "white",
          border: "1px solid rgba(255,255,255,0.3)",
          borderRadius: 4,
          padding: "8px 24px",
          fontFamily: "monospace",
          fontSize: 13,
          cursor: "pointer",
          alignSelf: "center",
          marginTop: 8,
        }}
      >
        Back
      </button>
    </div>
  );
}

function Key({ label }: { label: string }) {
  return (
    <span
      style={{
        display: "inline-block",
        border: "1px solid rgba(255,255,255,0.45)",
        borderRadius: 3,
        padding: "2px 6px",
        fontSize: 11,
        lineHeight: 1,
        minWidth: 18,
        textAlign: "center",
        color: "white",
        background: "rgba(255,255,255,0.05)",
      }}
    >
      {label}
    </span>
  );
}
